import React from 'react';
import { FIDELIZACION_DATA } from '@/data/mock';
import { SolutionPageLayout } from '@/components/shared/SharedComponents';
import {
  Star, Layers, Target, ShoppingBag, PieChart, Plug,
  Store, Utensils, CreditCard
} from 'lucide-react';

const featureIcons = { Star, Layers, Target, ShoppingBag, PieChart, Plug };
const audienceIcons = { Store, Utensils, CreditCard };

export default function FidelizacionPage() {
  return (
    <SolutionPageLayout
      heroData={FIDELIZACION_DATA.hero}
      features={FIDELIZACION_DATA.features}
      stats={FIDELIZACION_DATA.stats}
      audiences={FIDELIZACION_DATA.audiences}
      featureIcons={featureIcons}
      audienceIcons={audienceIcons}
    />
  );
}
